<template>
  <div class="grow">
    <div class="content ">
      <div class="st-dc-container">
        <img class="st-dc-bg" src="/stranger/assets/images/ST_DIGICODE_BG.png" />
        <img class="st-dc-led-red" v-if="showRed" src="/stranger/assets/images/ST_DIGICODE_LED_RED.png" />
        <img class="st-dc-led-green" v-if="showGreen" src="/stranger/assets/images/ST_DIGICODE_LED_GREEN.png" />         
        <div class="st-dc-button st-dc-b-top st-dc-b-left" @click="click('1')">1</div>
        <div class="st-dc-button st-dc-b-top st-dc-b-center" @click="click('2')">2</div>                                                              
        <div class="st-dc-button st-dc-b-top st-dc-b-right" @click="click('3')">3</div>
        <div class="st-dc-button st-dc-b-mid st-dc-b-left" @click="click('4')">4</div>
        <div class="st-dc-button st-dc-b-mid st-dc-b-center" @click="click('5')">5</div>                                                              
        <div class="st-dc-button st-dc-b-mid st-dc-b-right" @click="click('6')">6</div>  
        <div class="st-dc-button st-dc-b-mid2 st-dc-b-left" @click="click('7')">7</div>
        <div class="st-dc-button st-dc-b-mid2 st-dc-b-center" @click="click('8')">8</div>                                                              
        <div class="st-dc-button st-dc-b-mid2 st-dc-b-right" @click="click('9')">9</div>
        <div class="st-dc-button st-dc-b-bot st-dc-b-left" @click="click('*')">*</div>
        <div class="st-dc-button st-dc-b-bot st-dc-b-center" @click="click('0')">0</div>                                                              
        <div class="st-dc-button st-dc-b-bot st-dc-b-right" @click="click('#')">#</div>                      
      </div> 
    </div>
    <Sound src="/stranger/assets/audio/digicode_beep.mp3" volume="0.4" ref="beepSound" />
    <Sound src="/stranger/assets/audio/digicode_wrong.mp3" volume="0.4" ref="wrongSound" />
    <Sound src="/stranger/assets/audio/digicode_correct.mp3" volume="0.4" ref="correctSound" />    
  </div>
</template>

<script>
import Sound from "@/components/stranger/Sound";
import currentGameMixin from "@/mixins/currentGameMixin";

export default {
  name: "Digicode",
  data() {
    return {
      inputCode: "",
      maxLength: 4,
      showError: false,
      timeout: null,
      showRed: false,
      showGreen: false,
    };
  },
  components: { Sound },
  emits: ["onCodeSuccess"],
  mixins: [currentGameMixin],
  props: {
    correctCode: String,
  },
  methods: {
    clickSound() {
      if (this.showGreen) {
        this.$refs.clickSound.stop();
        this.$refs.clickSound.play();
      } else {
        this.$refs.beepSound.stop();
        this.$refs.beepSound.play();
      }
    },    
    correct() {
      this.$refs.correctSound.play();      
      this.showGreen = true;
      setTimeout(() => {
        this.$emit("onCodeSuccess", this.inputCode);
      }, 1000);
    },
    wrong() {
      this.$refs.wrongSound.play();
      this.inputCode = '';
      this.showRed = true;
    },
    click(b) {
      console.log(b);
      this.showRed = false;
      this.clickSound();

      if (this.showGreen) return;

      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.inputCode += b.toString();
      if (this.inputCode.length < 4) {
        this.timeout = setTimeout(() => {
          this.wrong();
        }, 3000)
      } else {
        if (this.inputCode == this.correctCode) {
          this.correct();
        } else {
          this.wrong();
        }
      }
    },
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
  .content {
    max-height: 550px;
    overflow-y: auto;

    .st-dc-container {
      margin: auto;
      width: 300px;
      height: 500px;
      position: relative;

      img.st-dc-bg {
        max-width: 300px;
        margin-top: 8px;
        left: 0px;
        top: 0px;

        position: absolute;        
      }

      img.st-dc-led-red {
        max-width: 22px;
        margin-top: 8px;
        left: 224px;
        top: 80px;
        position: absolute;        
      } 
      
      img.st-dc-led-green {
        max-width: 22px;
        margin-top: 8px;
        left: 256px;
        top: 80px;
        position: absolute;        
      }      

      div.st-dc-button {
        max-width: 65px;
        position: absolute;
        width: 56px;
        height: 60px;
        cursor: pointer;
        font-size: 24px;
        text-align: center;
        padding-top: 14px;

        background-image: url(/stranger/assets/images/ST_DIGICODE_KEY_OFF.png);
        background-size: 56px 60px;

        &:active {
          background-image: url(/stranger/assets/images/ST_DIGICODE_KEY_ON.png);
          padding-top: 18px;

        }

        &.st-dc-b-top { top: 149px; }
        &.st-dc-b-mid { top: 223px; }        
        &.st-dc-b-mid2 { top: 297px; }
        &.st-dc-b-bot { top: 371px; }

        &.st-dc-b-left { left: 44px; }
        &.st-dc-b-center { left: 123px; }
        &.st-dc-b-right { left: 197px; }

      }      
    }
  }
</style>